<!--
 * @Author: Nemo
 * @Description: OnDialog组件 - 响应式弹窗组件，PC端居中显示，移动端从底部弹出
 * @Date: 2025-11-19
-->
<template>
  <component
    :is="currentComponent"
    ref="dialogComponent"
    :visible="isVisible"
    :title="dialogTitle"
    :close-on-click-mask="dialogCloseOnClickMask"
    :show-default-footer="dialogShowDefaultFooter"
    :confirm-text="dialogConfirmText"
    :cancel-text="dialogCancelText"
    @update:visible="handleVisibleChange"
    @close="handleClose"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  >
    <template v-if="$slots.default" slot>
      <slot></slot>
    </template>
    <template v-if="$slots.footer" slot="footer">
      <slot name="footer"></slot>
    </template>
  </component>
</template>

<script>
import OnDialogMobile from './mobile.vue';
import OnDialogPC from './pc.vue';

export default {
  name: 'OnDialog',
  components: {
    OnDialogPC,
    OnDialogMobile,
  },
  data() {
    return {
      isMobile: /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent),
      isVisible: false,
      dialogTitle: '',
      dialogCloseOnClickMask: true,
      dialogShowDefaultFooter: true,
      dialogConfirmText: '确认',
      dialogCancelText: '取消',
    };
  },
  computed: {
    /**
     * 根据设备类型返回对应的组件
     * @returns {String} 组件名称
     * @author Nemo
     */
    currentComponent() {
      return this.isMobile ? 'OnDialogMobile' : 'OnDialogPC';
    },
  },
  mounted() {
    window.addEventListener('resize', this.checkDevice);
    this.checkDevice();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    /**
     * 打开弹窗
     * @param {Object} options - 弹窗配置选项
     * @author Nemo
     */
    open(options = {}) {
      this.dialogTitle = options.title || '';
      this.dialogCloseOnClickMask = options.closeOnClickMask !== undefined ? options.closeOnClickMask : true;
      this.dialogShowDefaultFooter = options.showDefaultFooter !== undefined ? options.showDefaultFooter : true;
      this.dialogConfirmText = options.confirmText || '确认';
      this.dialogCancelText = options.cancelText || '取消';
      this.isVisible = true;
    },

    /**
     * 关闭弹窗
     * @author Nemo
     */
    close() {
      this.isVisible = false;
    },

    /**
     * 检测设备类型
     * @author Nemo
     */
    checkDevice() {
      const screenWidth = window.innerWidth;
      this.isMobile = screenWidth <= 768 || /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
    },

    /**
     * 处理visible变化
     * @author Nemo
     */
    handleVisibleChange(val) {
      this.isVisible = val;
    },

    /**
     * 处理关闭事件
     * @author Nemo
     */
    handleClose() {
      this.isVisible = false;
      this.$emit('close');
    },

    /**
     * 处理取消事件
     * @author Nemo
     */
    handleCancel() {
      this.isVisible = false;
      this.$emit('cancel');
    },

    /**
     * 处理确认事件
     * @author Nemo
     */
    handleConfirm() {
      this.$emit('confirm');
      const componentRef = this.$refs.dialogComponent;
      if (componentRef && typeof componentRef.handleClose === 'function') {
        componentRef.handleClose();
      } else {
        this.isVisible = false;
      }
    },
  },
};
</script>

